import { toast } from "react-toastify";
import { ConstanciaFCursoAdmi, CertificadoFCursoAdmi, CertificadoFProgramaEspecializacion } from "../services/CertificadosServices";
import { ObtenerCertificadoPersonaCurso, ObtenerConstanciaPersonaCurso, ObtenerCertificadoPersonaPrograma } from "../services/UsuarioService";
import * as constantes from "../constants/constantes.js";
const ENDPOINTCDN = constantes.URLAPICDN;

export const formatTimefromSeconds = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");
  const formattedSeconds = secs.toString().padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};
export const timeToSeconds = (time) => {
  const parts = time.split(":");
  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  const seconds = parseInt(parts[2], 10);

  return hours * 3600 + minutes * 60 + seconds;
};

export const buscarConfiguracion = (lista, codigo) => {
  if (lista) {
    let resultado = lista.find(x => x.codigo == codigo)
    if (resultado) return resultado.valor
    else return ''
  }
  else {
    return ''
  }
}
export const DescargarFromBase64 = (data, nombre) => {
  const byteCharacters = atob(data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/octet-stream' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', nombre + '_Materiales.zip');
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
  //setButtonDisabledMateriales(false);
}
export function duracionEnHoras(duracion) {
  const partes = duracion.split(" ");
  if (partes.length === 2 && partes[1] === "h") {
    return parseFloat(partes[0]);
  }
  return 0;
}

export const urlToShare = 'https://cdn.inlearning.edu.pe/ZegelVirtual/Certificado/';//CERCURDIP-Huaman-20_2_2025-164029.pdf, lo enviara el back
//Logica optimizada para descargar el certificado
export const handleDownloadCertificado = async (cursoPersona) => {
    try {
      console.log("cursoPersona",cursoPersona);
      
      let fechainicio;
      let fechafin;
      const currentDate = new Date();
      const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}_${String(currentDate.getMonth() + 1).padStart(2, '0')}_${String(currentDate.getFullYear()).slice(-2)}`;
      // Obtener el JWT una vez
      const jwt = window.localStorage.getItem("jwt");

      // Estrategia en base al tipo de producto
      const strategies = {
        InternalCourse: async () => {
          const cursoDat = cursoPersona.cursoPersona.find(x => x.idCurso === cursoPersona.curso.idCurso);
          const IdPersonaCurso = cursoDat?.idPersonaCurso;
          return await ObtenerCertificadoPersonaCurso({ jwt, IdPersonaCurso });
        },
        Program: async () => {
          const IDPersonaPrograma = cursoPersona.cursoPersona.idPersonaPrograma;
          const datacertProg = await ObtenerCertificadoPersonaPrograma({ jwt, IDPersonaPrograma });
        
          // Calcular fecha de inicio y fin del programa
          cursoPersona.listaCursoPrograma.slice(1).forEach(curso => {
            fechainicio = fechainicio ? Math.min(fechainicio, curso.fechaActivacion) : curso.fechaActivacion;
            fechafin = fechafin ? Math.max(fechafin, curso.finCurso) : curso.finCurso;
          });
          return datacertProg;
        },
        Curso: async () => {
          const IdPersonaCurso = cursoPersona.cursoPersona.idPersonaCurso;          
          return await ObtenerCertificadoPersonaCurso({ jwt, IdPersonaCurso });
        },
        Constancia: async () => {
          const IdPersonaCurso = cursoPersona.cursoPersona.idPersonaCurso;
          console.log("IdPersonaCurso", IdPersonaCurso)
          return await ObtenerConstanciaPersonaCurso({ jwt, IdPersonaCurso });
          //return await ObtenerCertificadoPersonaCurso({ jwt, IdPersonaCurso });
        }
      };
    
    // Ejecutar la estrategia correspondiente o la default si no se encuentra
    const dataCert = await (strategies[cursoPersona.tipo] || strategies.default)();
    // Destructurar datos del alumno
    const { nombres = "", primerApellido = "", segundoApellido = "" } = cursoPersona.persona;
    const nombrealumno = `${nombres.trim()} ${primerApellido.trim()} ${segundoApellido.trim()}`.trim();

    // Obtener nombre del curso o programa
    const nombrecursoprograma = cursoPersona.tipo === "Program" ? cursoPersona.programa.nombre : dataCert.curso.nombre;
    const ubicacion = "Lima";
    const enlace =  urlToShare //dataCert.LinkCDN
    ? `${urlToShare}${limpiarNombreArchivo(cursoPersona.persona.primerApellido.trim())}-${formattedDate.trim()}-${dataCert.codigoCertificado.split('-').slice(1, 3).join('-').trim()}.pdf`
    : '';
    const fileName = `${limpiarNombreArchivo(cursoPersona.persona.primerApellido.trim())}-${formattedDate.trim()}-${dataCert.codigoCertificado.split('-').slice(1, 3).join('-').trim()}`;
    const codigo = dataCert.codigoCertificado;
    const enlaceQR = constantes.URL_CERTIFICATE +"/ValidateCertificateQR?codigo="+ dataCert.codigoCertificado + "&tipo=1";
    const totalhoras = cursoPersona.tipo === "Program"
      ? cursoPersona.programa.duracion.replace(/[^0-9.,]/g, '') || "0"
      : dataCert.curso.duracion.replace(/[^0-9.,]/g, '') || "0";

    fechainicio = cursoPersona.tipo === "Program"
      ? (dataCert.fechaActivacionPrograma || fechainicio)
      : dataCert.fechaActivacion;

    fechafin = cursoPersona.tipo === "Program"
      ? (dataCert.finPrograma || fechafin)
      : (dataCert.finCurso || dataCert.fechaVigencia);
   
    const response = { link: enlace, fileName };

    const jsonData = JSON.stringify({
      nombrealumno,
      nombrecursoprograma,
      ubicacion,
      enlace,
      enlaceQR,
      codigo,
      totalhoras,
      fechainicio,
      fechafin
    });

    /*const jsonDataConstancia = JSON.stringify({
      nombrealumno,
      nombrecursoprograma,
      ubicacion,
      enlace,
      enlaceQR,
      codigo      
    });*/

       const dataCDN = {
        Extension: enlace.split('.').pop(),
        NombreCDN: fileName
      };

    // Llamar al servicio correspondiente según el tipo de curso
    /*const ok = cursoPersona.tipo === "Program"
      ? await CertificadoFProgramaEspecializacion({ jwt, jsonData, dataCDN })
      : await CertificadoFCursoAdmi({ jwt, jsonData, dataCDN });
    */
    let ok;
    if (cursoPersona.tipo === "Program") {
      ok = await CertificadoFProgramaEspecializacion({ jwt, jsonData, dataCDN });
    }
    else if (cursoPersona.tipo === "Constancia") {      
       const jsonData = JSON.stringify({
        nombrealumno,
        nombrecursoprograma,
        ubicacion,
        enlace,
        enlaceQR,
        codigo        
      });
      ok = await ConstanciaFCursoAdmi({ jwt, jsonData, dataCDN }); // NUEVO
    }
    else if (cursoPersona.tipo === "Curso") {
      ok = await CertificadoFCursoAdmi({ jwt, jsonData, dataCDN });
    }  

    if(ok){ return response }
    return toast.error("Ocurrio un error inesperado, intenta de nuevo más tarde.");
    
  } catch (error) {
      toast.error(MessageErrorDownload,{ autoClose: 3000});
  }
};

const limpiarNombreArchivo = (primerapellido) => {
  return primerapellido
    ?.trim()
    .normalize('NFD')                    // separa tildes
    .replace(/[\u0300-\u036f]/g, '')     // elimina tildes
    .replace(/[^a-zA-Z0-9-_]/g, '')     // reemplaza caracteres especiales
    .replace(/_+/g, '');                // evita ____
};

export const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(',')[1]); // solo base64 puro
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const uploadFile = async (dataCDN) => {
  try {
    const res = await fetch(`${ENDPOINTCDN}/archivo/guardar`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "accept": "application/json"
      },
      body: JSON.stringify(dataCDN)
    });

    if (!res.ok) {
      if (res.status !== 401) {
        toast.error("Ocurrió un error en el servidor",{ autoClose: 3000});
        return;
      }
      window.localStorage.removeItem('jwt');
      window.location.reload();
    }

    return res;
  } catch (error) {
    toast.error("Error al subir el archivo:", error ,{ autoClose: 3000});
  }
};

export const donwloadFile = async (data) => {
    try {
      const response = await fetch(data.link);
      if (!response.ok) return toast.error("No se pudo descargar el archivo",{ autoClose: 3000});
  
      const blob = await response.blob();
       //esv
      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, '_blank');
      //esv

      const urlBlob = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = urlBlob;
      a.download = data.fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(urlBlob);
    } catch (error) {
      toast.error("Error al descargar el archivo:", error,{ autoClose: 3000});
    }
  };

//Bloque de mensajes para las notificaciones
export const MessageError = "No se pudo copiar el enlace. Intenta nuevamente.";
export const MessageSuccess = "Enlace copiado con éxito.";
export const MessageErrorPDF = "Hubo un problema al cargar el PDF. Intenta recargar la página.";
export const MessagePDFSuccess = "PDF cargado con éxito";
export const MessageErrorDownload = "No se pudo descargar el certificado. Intenta de nuevo más tarde."
export const MessageErrorFileName = "No se pudo encontrar el certificado. Intenta de nuevo más tarde."
// export const SAVE_FILE = "http://cdn.inlearning.edu.pe/ZegelVirtual/"

export const FaXTemporary = ({ size = 24, color = 'currentColor', style = {}, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    viewBox="0 0 24 24"
    width={size}
    height={size}
    style={{ verticalAlign: 'middle', ...style }}
    {...props}
  >
    <path d="M21.5 2h-4.75L12 7.5 7.25 2H2l7.75 10L2 22h4.75L12 16.5 16.75 22H22l-7.75-10L22 2z" />
  </svg>
);

//Link del worker para la previsualización del pdf
export const URL_WORKER = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.12.313/pdf.worker.min.js`;

//bloque para publicación en las distintas redes sociales
export const windowShare = 'width=600,height=800,top=100,left=100,resizable=yes,scrollbars=yes';

export const FacebookPublish =(input) => {
  return`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(input)}`;
}

export const TwitterPublish =(input) => {
  return `https://x.com/intent/tweet?url=${encodeURIComponent(input)}`;
}

export const LinkedInPublish =(input) => {
  return`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(input)}`;
}

export const WhatsAppPublish =(input) => {
  const textToShare = `¡Orgulloso de este nuevo logro! Gracias a *Zegel Virtual* he obtenido un nuevo certificado que me impulsa hacia adelante. Echa un vistazo al certificado aquí.🔥 ${input}`;
  const encodedText = encodeURIComponent(textToShare);
  return `https://api.whatsapp.com/send?text=${encodedText}`;
}

